export const CATALOGUE_VISITOR_TOKEN_KEY = "hkp_catalogue_visitor_token";
export const CATALOGUE_VISITOR_PROFILE_KEY = "hkp_catalogue_visitor_profile";

export type CatalogueVisitorProfile = {
  visitorId: string;
  name: string;
  phone: string;
  email?: string;
};

export function getCatalogueVisitorToken(): string | null {
  const raw = localStorage.getItem(CATALOGUE_VISITOR_TOKEN_KEY);
  if (!raw || !String(raw).trim()) return null;
  return String(raw).trim();
}

export function setCatalogueVisitorToken(token: string) {
  localStorage.setItem(CATALOGUE_VISITOR_TOKEN_KEY, String(token).trim());
}

export function clearCatalogueVisitorSession() {
  localStorage.removeItem(CATALOGUE_VISITOR_TOKEN_KEY);
  localStorage.removeItem(CATALOGUE_VISITOR_PROFILE_KEY);
}

export function getCachedCatalogueVisitorProfile(): CatalogueVisitorProfile | null {
  try {
    const raw = localStorage.getItem(CATALOGUE_VISITOR_PROFILE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as CatalogueVisitorProfile;
    if (p && p.visitorId && p.phone) return p;
  } catch {
    /* ignore */
  }
  return null;
}

export function setCachedCatalogueVisitorProfile(p: CatalogueVisitorProfile) {
  localStorage.setItem(CATALOGUE_VISITOR_PROFILE_KEY, JSON.stringify(p));
}

/** Value for `X-HKP-Catalogue-Visitor` request header. */
export function catalogueVisitorAuthHeaderValue(): string | null {
  const t = getCatalogueVisitorToken();
  if (!t) return null;
  return t.startsWith("Bearer ") ? t : `Bearer ${t}`;
}

/** Remember last public catalogue grid (for “back to collection” from visitor account). */
export const LAST_VISITED_CATALOGUE_KEY = "hkp_catalogue_last_visit";

export type LastVisitedCatalogueState = {
  catalogueId: string;
  /** Query string without leading `?` (token, session, priceTier, …). */
  search: string;
};

export function rememberLastVisitedCatalogue(catalogueId: string, search: string) {
  if (!catalogueId || !String(catalogueId).trim()) return;
  try {
    const payload: LastVisitedCatalogueState = {
      catalogueId: String(catalogueId).trim(),
      search: search.startsWith("?") ? search.slice(1) : search,
    };
    localStorage.setItem(LAST_VISITED_CATALOGUE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function getLastVisitedCatalogue(): LastVisitedCatalogueState | null {
  try {
    const raw = localStorage.getItem(LAST_VISITED_CATALOGUE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<LastVisitedCatalogueState>;
    if (p && typeof p.catalogueId === "string" && p.catalogueId.trim()) {
      return {
        catalogueId: p.catalogueId.trim(),
        search: typeof p.search === "string" ? p.search : "",
      };
    }
  } catch {
    /* ignore */
  }
  return null;
}
